import type React from 'react';

import googleMapsLogo from '#src/assets/googleMaps/google-maps-logo.svg';

export const GoogleMapsAttribution: React.FC<EmptyProps> = () => (
	<div className="border-stroke-weaker flex justify-end border-t px-4 py-2.5">
		<a
			href="https://www.google.com/maps"
			target="_blank"
			rel="noopener noreferrer"
			tabIndex={-1}
			aria-label="Google Maps"
		>
			<div
				aria-hidden
				className="bg-icon-strong h-[18px] w-[98px]"
				style={{
					maskImage: `url(${googleMapsLogo})`,
					WebkitMaskImage: `url(${googleMapsLogo})`,
					maskSize: 'contain',
					WebkitMaskSize: 'contain',
					maskRepeat: 'no-repeat',
					WebkitMaskRepeat: 'no-repeat',
					maskPosition: 'center',
					WebkitMaskPosition: 'center',
				}}
			/>
		</a>
	</div>
);
